(function (Drupal) {
  Drupal.behaviors.burgerMenu = {
    attach(context) {
      let activeTab = null;
      once('burgerMenu', '#header-modal-menu .nav .nav-item.dropdown .nav-link', context).forEach(function (el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.classList.contains('active')) {
            if (activeTab === e.target) {
              const tab = document.querySelector(e.target.getAttribute('data-bs-target'));

              e.target.classList.remove('active');
              if (tab.classList.contains('show')) {
                tab.classList.remove('active', 'show');
                activeTab = null;
              }
            } else {
              activeTab = e.target;
            }
          }
        });
      })
      // Hide Burger Menu after click by second menu level links.
      once('clickBurgerMenuItem', '#header-modal-menu .menu-level-2 a, #header-modal-menu .accordion-body a', context).forEach(function (el) {
        el.addEventListener('click', (e) => {
          const closeBurgerMenuBtn = document.querySelector('.modal-header .close');
          closeBurgerMenuBtn.click()
        });
      })
    }
  };
})(Drupal);
